import type { ViewName } from '../store'

export type Section = 'sales005' | 'insights' | 'testdata' | 'beheer'

export const VIEW_SECTION: Partial<Record<ViewName, Section>> = {
  upload:             'sales005',
  result:             'sales005',
  history:            'sales005',
  scenarios:          'sales005',
  'replace-profiles': 'sales005',
  pricelists:         'sales005',
  validator:              'insights',
  'bulk-rename':          'insights',
  'testdata-generator':   'testdata',
  'party-presets':        'testdata',
  users:              'beheer',
  logs:               'beheer',
  'admin-settings':   'beheer',
  'audit-log':        'beheer',
}

export const SECTION_DEFAULT: Record<Section, ViewName> = {
  sales005: 'upload',
  insights: 'validator',
  testdata: 'testdata-generator',
  beheer:   'admin-settings',
}

export interface SubNavItem {
  view: ViewName
  label: string
  adminOnly?: boolean
  condition?: boolean
}

export function SubNavBtn({ label, active, onClick }: { label: string; active: boolean; onClick: () => void }) {
  return (
    <button
      onClick={onClick}
      className={`px-3 py-1 rounded-md text-xs font-medium transition-colors ${
        active
          ? 'bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 shadow-sm border border-gray-200 dark:border-gray-600'
          : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 hover:bg-white/70 dark:hover:bg-gray-700/70'
      }`}
    >
      {label}
    </button>
  )
}
